import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, withHashLocation } from '@angular/router';
import { provideHttpClient,withInterceptors } from '@angular/common/http';
import { AppComponent } from './app/app.component';
import { Routes } from '@angular/router';
import { importProvidersFrom } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { jwtInterceptor } from './app/core/services/jwt.interceptor';
import { NgxSpinnerModule } from 'ngx-spinner'; 

const routes: Routes = [
  {
    path: '',
    redirectTo: 'amba',
    pathMatch: 'full',
  },
  {
    path: 'amba',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./app/features/landing/landing.component').then(
            (m) => m.LandingComponent
          ),
      },
      {
        path: 'ieee',
        loadChildren: () =>
          import('./app/features/clients/ieee/ieee-routing.module').then(
            (m) => m.IeeeRoutingModule
          ),
      },
      {
        path: 'asme',
        loadChildren: () =>
          import('./app/features/clients/asme/asme.module').then(
            (m) => m.AsmeModule
          ),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'amba',
  },
];

bootstrapApplication(AppComponent, {
  providers: [
     provideAnimations(),
    provideRouter(routes , withHashLocation()),
    provideHttpClient(withInterceptors([jwtInterceptor])),
    importProvidersFrom(NgxSpinnerModule.forRoot({ type: 'ball-spin-clockwise' }))
  ],
}).catch((err) => console.error(err));

